module.exports = __webpack_public_path__ + "static/media/uae.80dfc6ce.webp";